<script>

import _ from "lodash";

export default {
    name: "VDataTableCustomHeaderFiltersText",
    inheritAttrs: false,
    props: {
        header: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
        },
    },
    methods: {
        filterItems(items) {
            const filterValueLc = (this.value || "").toLowerCase(),
                headerValue = this.header.value;
            return filterValueLc.length ? _.filter(
                items,
                item => {
                    const value = _.get(item, headerValue);
                    return ((value || "").toString().toLowerCase().indexOf(filterValueLc) !== -1);
                }) : items;
        },
    },
}
</script>

<template>
    <v-text-field
        v-bind="$attrs"
        v-on="$listeners"
        :value="value"
        :label="header?.text"
        clearable
        hide-details
        single-line
        class="mb-4"
        dense
    ></v-text-field>
</template>

<style scoped lang="scss">

</style>
